import React from 'react';
import { Helmet } from 'react-helmet-async';

interface DynamicMetaProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
  authorName?: string;
  publishedTime?: string;
}

export const DynamicMeta: React.FC<DynamicMetaProps> = ({
  title,
  description,
  image,
  url,
  type = 'article',
  authorName,
  publishedTime,
}) => {
  const siteTitle = title ? `${title} | Literally` : 'Literally - Social Publishing & Poetry';
  const cleanDesc = description
    ? description.replace(/<[^>]*>/g, '').slice(0, 160)
    : 'Read and publish poems, stories, and articles on Literally.';
  const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : 'https://www.literally.com.ng');
  const ogImage = image || 'https://www.literally.com.ng/og-image.jpg';

  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="description" content={cleanDesc} />
      
      {/* OpenGraph */}
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={cleanDesc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content={type} />
      {authorName && <meta property="article:author" content={authorName} />}
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={cleanDesc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
